<script>
    import DropdownActions from '../actions/DropdownActions'
    import SortingAnchorTag from '../sorting/TableColumnSortAnchorTag.vue'
    import { eventBus } from '../../../Pages/assets/eventBus.js'

    export default {
        components: {
            DropdownActions,
            SortingAnchorTag
        },
        props: {
            columns: Array,
            datas: {
                type: Array,
                default: function () {
                    return [];
                },
            },
            clientListType: String,
            onClick: Function,
            onClickToLogin: Function,
            showOnboardingChecklistModalFunc: Function
        },
        data() {
            return {
                isDisabledDescending: false,
                isDisabledAscending: false
            }
        },
        computed: {
            // Example 1,2,3,4
            userType() {
                return this.$page.props.auth.user.user_type;
            },
            isEmployed() {
                return this.$page.props.auth.user.session_is_employed;
            },
            isShowStatusColumn() {
                return !this.$page.props.auth.user.is_it_locked_account && this.$page.props.auth.user.login_user_is_paid ? true : false
            },
            currentRoute() {
                let shortUserType = this.$page.props.auth.user.user_type_abbr
                let currentRouteName = ''
                if(this.clientListType == 'EP') {
                    currentRouteName = `${shortUserType}-sb-list`
                } else if(this.clientListType == 'TC') {
                    currentRouteName = `${shortUserType}-tc-list`
                } else if(this.clientListType == 'TP') {
                    currentRouteName = `${shortUserType}-tp-list`
                } else {
                    currentRouteName = `${shortUserType}-contacts`
                }
                return currentRouteName
            }
        },
        created() {
            eventBus.$off('manageSortingAtSearchUser')
            eventBus.$on('manageSortingAtSearchUser', () => {
                this.isDisabledDescending = false
                this.isDisabledAscending = false
            })
            eventBus.$off('sortingColumn')
            eventBus.$on('sortingColumn', (datas) => {
                let baseURL = window.location.href.split("?");
                let routeStringParam = {}
                if(baseURL.length > 1) {
                    let allParam = baseURL[1].split("&")
                    let strings = null;
                    for(let i = 0; i < allParam.length; i++) {
                        strings = allParam[i].split("=")
                        routeStringParam[strings[0]] = strings[1]
                    }
                }
                routeStringParam[datas.item] = datas.value
                this.manageSortingButtonDisablity(datas.value)
                this.$inertia.get(
                    route(this.currentRoute, [routeStringParam]),
                    {},
                    {
                        preserveState: true
                    }
                )
            })
            let baseURL2 = window.location.href.split("?")
            if(baseURL2.length > 1) {
                let allParam2 = baseURL2[1].split("&")
                let strings2 = null;
                for(let i = 0; i < allParam2.length; i++) {
                    strings2 = allParam2[i].split("=")
                    if(strings2[0] === 'name_sort_by') {
                        this.manageSortingButtonDisablity(strings2[1])
                        break;
                    }
                }
            }
        },
        methods: {
            manageSortingButtonDisablity(value) {
                if(value == 'DESC') {
                    this.isDisabledDescending = true
                    this.isDisabledAscending = false
                } else {
                    this.isDisabledAscending = true
                    this.isDisabledDescending = false
                }
            }
        }
    }
</script>
<template>
    <div class="table-responsive">
        <table class="table project-list-table table-nowrap table-centered table-borderless align-middle">
            <thead>
                <tr>
                    <th scope="col">
                        Name
                        <SortingAnchorTag
                            :disabledAsc="isDisabledAscending"
                            :disabledDesc="isDisabledDescending"
                            sortParam="name_sort_by"
                            ascSortValue="ASC" 
                            descSortValue="DESC" 
                        />
                    </th>
                    <th scope="col">
                        Email
                    </th>
                    <th scope="col">
                        Phone
                    </th>
                    <th scope="col">
                        Account Manager
                    </th>
                    <th v-if="clientListType == 'All'" scope="col">
                        User Type
                    </th>
                    <th v-if="isShowStatusColumn" scope="col">
                        Status
                    </th>
                    <th scope="col">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in datas" :key="index">
                    <td>
                        <a :href="item.view_url" class="text-dark">
                            <div class="d-flex">
                                <div class="flex-shrink-0 align-self-center me-3">
                                    <div v-if="item.image.length == 0" class="avatar-xs">
                                        <span class="avatar-title rounded-circle bg-primary bg-soft text-primary"> {{item.nameFirstLetter | onlyFirstLetter}}</span>
                                    </div>
                                    <img v-else :src="item.image" class="rounded-circle avatar-xs" alt="">
                                </div>                                
                                <div class="flex-grow-1 overflow-hidden">
                                    <h5 class="text-truncate font-size-14 mb-1">{{item.full_name}}</h5>
                                    <p class="text-truncate mb-0">{{item.company}}</p>
                                </div>
                            </div>
                        </a>
                    </td>
                    <td>
                        <a :href="'mailto:' + item.email">
                            {{item.email | descriptionsLength(22)}}
                        </a>
                    </td>
                    <td>
                        <a :href="'tel:' + item.phone">{{ item.phone }}</a>
                    </td>
                    <td>
                    <a :href="item.acc_mngr_url">
                            {{item.acc_mngr | descriptionsLength(10)}}
                        </a>
                    </td>
                    <td v-if="clientListType == 'All'">{{item.userTypeText}}</td>
                    <td v-if="isShowStatusColumn">
                        <div v-if="item.statusData != undefined" @click="onClick(item.id, item.statusData.status, item.statusData.loginAttempts, item.statusData.paymentStatus, item.statusData.paymentColor, item.statusData.paymentTitle, item.statusData.paymentDetails, item.statusData.paymentDetailStatus, item.statusData.phaseStatus, item.statusData.phaseColor, item.statusData.phaseTitle, item.full_name, item.email, item.user_type, item.routesOrUrl)">
                            <button type='button' class='button information_button' style=' color: #fff; border: none; width: 30px; height: 30px; padding: 6px 0px; border-radius: 15px; font-size: 12px; text-align: center;' :style="'background-color:' + item.statusData.statusColor" :title="'Account Status: ' + item.statusData.statusTitle">S</button>
                            <button v-if="item.user_type != 4" type='button' class='button information_button' style='color: #fff; border: none; width: 30px; height: 30px; padding: 6px 0px; border-radius: 15px; font-size: 12px; text-align: center;' :style="'background-color:' + item.statusData.paymentColor" :title="'Payment Status:' + item.statusData.paymentDetailStatus">P</button>
                            <button type='button' class='button information_button' style='color: #fff; border: none; width: 30px; height: 30px; padding: 6px 0px; border-radius: 15px; font-size: 12px; text-align: center;' :style="'background-color:' + item.statusData.phaseColor" :title="'Lead Type:' + item.statusData.phaseTitle">L</button>
                        </div>
                    </td>
                    <td>
                        <DropdownActions 
                            classes="card-drop"
                            variant="white"
                            site="left"
                            toggleClasses="p-0"
                            menuClasses="dropdown-menu-end"
                        >
                            <i class="mdi mdi-dots-horizontal font-size-18" slot="buttonSlot"></i>
                            <b-dropdown-item :href="item.view_url">
                                <i class="bx bx-show-alt"></i>
                                View
                            </b-dropdown-item>
                            <template v-if="item.routesOrUrl != undefined && item.statusData != undefined">
                                <b-dropdown-item v-if="item.user_type != 4 && item.routesOrUrl.loginAs" @click="onClickToLogin(item.routesOrUrl.loginAs, item.id)">
                                    <i class="bx bx-log-in-circle"></i>
                                    Login
                                </b-dropdown-item>
                                <b-dropdown-item v-else-if="item.routesOrUrl.loginAs" :href="item.routesOrUrl.loginAs">
                                    <i class="bx bx-log-in-circle"></i>
                                    Login
                                </b-dropdown-item>
                                <b-dropdown-item v-if="item.msg_url" :href="item.msg_url">
                                    <i class="bx bx-message-rounded-dots"></i>
                                    Message
                                    <span v-if="item.msg_total > 0" class="badge bg-danger ms-1">{{item.msg_total}}</span>
                                </b-dropdown-item>
                                <b-dropdown-item 
                                    v-if="userType == 2 && (item.onBoardingChecklist && item.onBoardingChecklist.length > 0) && (clientListType == 'TC' || (clientListType == 'All' && item.userTypeText == 'TC'))" 
                                    @click="showOnboardingChecklistModalFunc(true, item.onBoardingChecklist)"
                                >
                                    <i class="bx bx-list-check"></i>
                                    Onboarding Checklist
                                </b-dropdown-item>
                            </template>
                        </DropdownActions>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>